window.globalization = window.globalization || {};

window.globalization.convertToMomentFormat = function(s) {
    var momentMapping = {
        'dddd': 'dddd',
        'ddd': 'ddd',
        'dd': 'DD',
        'd': 'D',
        'yyyy': 'YYYY',
        'yy': 'YY'
    };
    return this.applyFormatMapping(s, momentMapping);
};

window.globalization.convertToBootstrapDatePickerFormat = function(s) {
    var datePickerMapping = {
        'MMMM': 'MM',
        'MMM': 'M',
        'MM': 'mm',
        'M': 'm',
        'dddd': 'DD',
        'ddd': 'D'
    };
    return this.applyFormatMapping(s, datePickerMapping);
};

window.globalization.applyFormatMapping = function (s, mapping) {
    var i = 0;
    for (var from in mapping) {
        s = s.replace(from, '~' + i + '~');
        i++;
    }
    i = 0;
    for (var from in mapping) {
        var to = mapping[from];
        s = s.replace('~' + i + '~', to);
        i++;
    }
    return s;
};

window.IsDefaultNumericCulture = function(culture) {
    var numberFormat = culture.NumberFormat;
    if (!numberFormat) {
        return false;
    }
    return (
        numberFormat.NumberDecimalSeparator === '.'
            && numberFormat.CurrencyDecimalSeparator === '.'
            && numberFormat.NumberGroupSeparator === ','
            && numberFormat.CurrencyGroupSeparator === ',');

};

window.globalization.applyCulture = function () {
    var culture = window.App.Data.Culture;
    var cultureNameLowerCase = culture.Name.toLowerCase();

    var is = {
        us: cultureNameLowerCase == 'en-us',
        ca: cultureNameLowerCase == 'en-ca',
        gb: cultureNameLowerCase == 'en-gb',
        au: cultureNameLowerCase == 'en-au',
        za: cultureNameLowerCase == 'en-za',
    };

    var dateTimeFormat = culture.DateTimeFormat;
    var shortTimePattern = dateTimeFormat.ShortTimePattern;
    var shortDatePattern = dateTimeFormat.ShortDatePattern;
    var dateSeparator = dateTimeFormat.DateSeparator;
    var uses24Hours = shortTimePattern.indexOf('H') > -1;
    var uses2DigitDay = shortDatePattern.indexOf('dd') > -1;
    var uses2DigitMonth = shortDatePattern.indexOf('MM') > -1;
    var shortDatePatternLowerCase = shortDatePattern.toLowerCase();
    var isDayBeforeMonth = shortDatePatternLowerCase.indexOf('d') < shortDatePatternLowerCase.indexOf('m');

    dateTimeFormat.IsDayBeforeMonth = isDayBeforeMonth;
    dateTimeFormat.Uses24Hours = uses24Hours;

    // Accounting.js
    accounting.setCulture(culture);

    var isMobile = window.App.UserAgent && (
        window.App.UserAgent.IsAndroid || window.App.UserAgent.IsIOS);
    window.App.NumberInputType = isMobile && IsDefaultNumericCulture(culture)
        ? 'number'
        : 'text';

    // Moment.js
    if (!is.us) {
        // since we don't use CommonJS, moment.js will not load language file, so the language file should be added to BundleConfiguration
        if (is.au) {
            moment.locale(cultureNameLowerCase, {
                longDateFormat : {
                    LT : 'HH:mm',
                    LTS : 'HH:mm:ss',
                    L : 'DD/MM/YYYY',
                    LL : 'D MMMM YYYY',
                    LLL : 'D MMMM YYYY HH:mm',
                    LLLL : 'dddd D MMMM YYYY HH:mm'
                },
            });
        } else {
            moment.locale(cultureNameLowerCase);
        }
    }
    else {
        // fixing L format to M/D/YYYY
        moment.localeData('en')._longDateFormat.L = 'M/D/YYYY';
        moment.locale('en');
    }
    dateTimeFormat.MomentShortDatePattern = this.convertToMomentFormat(shortDatePattern);
    dateTimeFormat.MomentShortYearDatePattern = dateTimeFormat.MomentShortDatePattern.replace('YYYY', 'YY');
    dateTimeFormat.MomentNoYearDatePattern = dateTimeFormat.MomentShortDatePattern
        .replace(dateTimeFormat.DateSeparator + 'YYYY', '')
        .replace(dateTimeFormat.DateSeparator + 'YY', '');
    dateTimeFormat.MomentShortTimePattern = moment.localeData(moment.locale())._longDateFormat.LT;
    dateTimeFormat.MomentShortYearDateTimePattern = dateTimeFormat.MomentShortYearDatePattern + ' ' + dateTimeFormat.MomentShortTimePattern;

    // Bootstrap-datepicker.js
    $.fn.datepicker.defaults.format = this.convertToBootstrapDatePickerFormat(shortDatePattern);

    // Bootstrap-timepicker.js
    $.fn.timepicker.defaults.showMeridian = !uses24Hours;

    // Fullcalendar.js
    if (!is.us) {
        var fcMonthFormat = uses2DigitMonth ? 'MM' : 'M';
        var fcDayFormat = uses2DigitDay ? 'dd' : 'd';
        var fcDayMonthFormat = isDayBeforeMonth ? fcDayFormat + dateSeparator + fcMonthFormat : fcMonthFormat + dateSeparator + fcDayFormat;

        dateTimeFormat.fullCalendarDateTimeFormat = {
            axisFormat: uses24Hours ? shortTimePattern : shortTimePattern.replace(':mm', '(:mm)'),
            timeFormat: {
                agenda: shortTimePattern + '{ - ' + shortTimePattern + '}',
                '': shortTimePattern
            },
            columnFormat: {
                month: 'ddd',
                week: 'ddd ' + fcDayMonthFormat,
                day: 'dddd ' + fcDayMonthFormat
            },
            titleFormat: {
                month: 'MMMM yyyy',
                week: isDayBeforeMonth ? 'd[ MMM][ yyyy]{ \'&#8212;\' d MMM yyyy}' : 'MMM d[ yyyy]{ \'&#8212;\'[ MMM] d yyyy}',
                day: 'dddd, ' + (isDayBeforeMonth ? 'd MMM' : 'MMM d') + ', yyyy'
            }
        };
    }

    // jQuery.validate.js
    if ($.validator) {
        if (!is.us) {
            $.validator.methods.date = function (value, element) {
                return this.optional(element) || moment(value, window.App.Data.Culture.DateTimeFormat.MomentShortDatePattern).isValid();
            };
        }
    }

    // Knockout.validation.js
    if (!is.us) {
        ko.validation.rules['date'].validator = function (value, validate) {
            if (value === undefined || value === null || value === '') {
                return true;
            }
            if (validate) {
                var m = Object.prototype.toString.call(value) === '[object Date]'
                    ? moment(value)
                    : moment(value, window.App.Data.Culture.DateTimeFormat.MomentShortDatePattern);
                return m.isValid();
            }
            return false;
        };
    }
};

window.globalization.getCountryNameByCode = function (code) {
    var dict = window.App.Data.CountryNameByCode;
    return dict[code] || dict['US'];
};

window.globalization.getCountryCodeByAddress = function (address) {
    if (address===undefined) {
        return null;
    }
    var s = address.toLowerCase();
    var dict = window.App.Data.CountryNameByCode;
    var name;
    for (var code in dict) {
        name = dict[code];
        if (s.endsWith(name.toLowerCase())) {
            return code;
        }
    }
    for (var code in dict) {
        if (s.endsWith(code.toLowerCase())) {
            return code;
        }
    }
    return null;
};

// Accounting.js extension
if (typeof accounting == 'undefined')
    window.accounting = {};
accounting.setCulture = function (culture) {

    var numberFormat = culture.NumberFormat;

    var c = this.settings.currency;
    c.symbol = numberFormat.CurrencySymbol;
    c.decimal = numberFormat.CurrencyDecimalSeparator;
    c.thousand = numberFormat.CurrencyGroupSeparator;
    c.precision = numberFormat.CurrencyDecimalDigits;
    c.format = {
        pos: numberFormat.CurrencyPositivePattern,
        neg: numberFormat.CurrencyNegativePattern,
        zero: numberFormat.CurrencyPositivePattern
    };

    var n = this.settings.number;
    n.decimal = numberFormat.NumberDecimalSeparator;
    n.thousand = numberFormat.NumberGroupSeparator;
    n.precision = numberFormat.NumberDecimalDigits;
};